import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Produktfeeds')
    .setRoute('product_feed_list')
    .setAdditionalRoutes([
        'product_feed',
    ]);
